import React, { useEffect, useState } from "react";
import LoginRoutes from "./loginRoutes";
import MainRoutes from "./mainRoutes";
import { useSelector } from "react-redux";

const Routing = ({data:permissionFromApi}) => {
  const isLoggedIn = useSelector((state) => state.auth.token);
  const userPermision = useSelector((state) => state?.auth?.user);

// if(isLoggedIn){
//   // if (!permissionFromApi) {
//   //   return <div>Loading...</div>; 
//   // }
// }
  // return <>{isLoggedIn ? <MainRoutes  permissions={permissionFromApi}  /> : <LoginRoutes />}</>;
    return <>{isLoggedIn ? <MainRoutes  /> : <LoginRoutes />}</>;
};

export default Routing;
